import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import { AppShell } from "./components/layout/AppShell";
import { LandingPage } from "./pages/LandingPage";
import { AuthPage } from "./pages/AuthPage";
import { ServersPage } from "./pages/ServersPage";
import { ServerDetailPage } from "./pages/ServerDetailPage";
import { PaymentsPage } from "./pages/PaymentsPage";
import { BillingPage } from "./pages/BillingPage";
import { AccountPage } from "./pages/AccountPage";
import { SupportPage } from "./pages/SupportPage";
import { ConfirmAccessPage } from "./pages/ConfirmAccessPage";

function ProtectedApp() {
  const { credentials } = useAuth();
  const location = useLocation();
  if (!credentials) return <Navigate to="/auth/login" replace state={{ from: location.pathname }} />;
  return <AppShell />;
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/auth/confirm" element={<ConfirmAccessPage />} />
      <Route path="/auth/:mode?" element={<AuthPage />} />
      <Route path="/app" element={<ProtectedApp />}>
        <Route index element={<Navigate to="servers" replace />} />
        <Route path="servers" element={<ServersPage />} />
        <Route path="servers/:serverId" element={<ServerDetailPage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="account" element={<AccountPage />} />
        <Route path="support" element={<SupportPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
